import React from 'react'
import { AlertTriangle, Info } from 'lucide-react'
import styles from './ProjectAutofillInfoNote.module.scss'
import cardStyles from './ProjectAutofillCard.module.scss'

export type ProjectAutofillInfoNoteVariant = 'hint' | 'rubroInfo' | 'lead' | 'muted'
export type ProjectAutofillInfoNoteTone = 'info' | 'caution'

type Props = {
  children: React.ReactNode
  variant?: ProjectAutofillInfoNoteVariant
  tone?: ProjectAutofillInfoNoteTone
  className?: string
}

const RUBRO_INFO_CLASS = cardStyles.projectAutofillRubroInfoNote

const VARIANT_CLASS: Record<ProjectAutofillInfoNoteVariant, string> = {
  hint: cardStyles.projectAutofillHint,
  rubroInfo: RUBRO_INFO_CLASS,
  lead: RUBRO_INFO_CLASS,
  muted: RUBRO_INFO_CLASS
}

const ProjectAutofillInfoNote: React.FC<Props> = ({
  children,
  variant,
  tone = 'info',
  className
}) => {
  const Icon = tone === 'caution' ? AlertTriangle : Info
  const rootClassName = [
    styles.root,
    tone === 'caution' ? styles.toneCaution : styles.toneInfo,
    variant ? VARIANT_CLASS[variant] : '',
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <p className={rootClassName} role="note">
      <Icon size={16} strokeWidth={2} className={styles.icon} aria-hidden />
      <span className={styles.content}>{children}</span>
    </p>
  )
}

export default ProjectAutofillInfoNote
